
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_1ykdk_97",
  "tools": "awsui_tools_wih1l_1ykdk_108",
  "tools-filtering": "awsui_tools-filtering_wih1l_1ykdk_114",
  "tools-align-right": "awsui_tools-align-right_wih1l_1ykdk_119",
  "tools-pagination": "awsui_tools-pagination_wih1l_1ykdk_123",
  "tools-preferences": "awsui_tools-preferences_wih1l_1ykdk_123",
  "tools-small": "awsui_tools-small_wih1l_1ykdk_129",
  "table": "awsui_table_wih1l_1ykdk_135",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_1ykdk_141",
  "wrapper": "awsui_wrapper_wih1l_1ykdk_145",
  "variant-stacked": "awsui_variant-stacked_wih1l_1ykdk_153",
  "variant-container": "awsui_variant-container_wih1l_1ykdk_153",
  "variant-embedded": "awsui_variant-embedded_wih1l_1ykdk_157",
  "has-header": "awsui_has-header_wih1l_1ykdk_160",
  "has-footer": "awsui_has-footer_wih1l_1ykdk_163",
  "cell-merged": "awsui_cell-merged_wih1l_1ykdk_177",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_1ykdk_188",
  "empty": "awsui_empty_wih1l_1ykdk_203",
  "loading": "awsui_loading_wih1l_1ykdk_207",
  "selection-control": "awsui_selection-control_wih1l_1ykdk_216",
  "selection-control-header": "awsui_selection-control-header_wih1l_1ykdk_223",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_1ykdk_228",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_1ykdk_238",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_1ykdk_241",
  "dark-header": "awsui_dark-header_wih1l_1ykdk_249",
  "header-secondary": "awsui_header-secondary_wih1l_1ykdk_253",
  "table-has-header": "awsui_table-has-header_wih1l_1ykdk_269",
  "header-controls": "awsui_header-controls_wih1l_1ykdk_273",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_1ykdk_287",
  "footer": "awsui_footer_wih1l_1ykdk_287",
  "thead-active": "awsui_thead-active_wih1l_1ykdk_296",
  "row": "awsui_row_wih1l_1ykdk_297",
  "row-selected": "awsui_row-selected_wih1l_1ykdk_298"
};
  